import React from 'react';
import ReactDOM from 'react-dom/client';
import './Styles.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n';

// Create the GTM dataLayer as early as possible, before any component mounts.
// GoogleTagManager only initialises it after the ~1.5s Didomi gate, but the
// first funnel event (funnel_step_1 on ClubSelection) fires as soon as the
// config loads, often sooner. Without this, that early push is dropped because
// window.dataLayer does not exist yet. Pre-creating the array lets early events
// buffer and be replayed by GTM once it loads. (root cause of MSDS-962)
window.dataLayer = window.dataLayer || [];

const rootDom = document.getElementById('root');
const root = ReactDOM.createRoot(rootDom);
root.render(
	<React.StrictMode>
		<React.Suspense fallback="loading">
			<App />
		</React.Suspense>
	</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
